import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionIdService } from './session-id.service';
import {environment} from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly sessionIdService: SessionIdService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const sessionId = this.sessionIdService.getSessionId();
    const correlationId = this.sessionIdService.getCorrelationId();
    let headerObject: any = {
        'Content-Type': 'application/json',
        'x-session-id': sessionId,
        // journey_id: echo the correlationId that the backend generated at startSurvey (received in
        // the entry redirect URL as ?cid=...) so every backend call in this respondent flow shares
        // the same journey_id (RESPONDENT_ENTRY -> RESPONDENT_FLOW -> CLIENT_REDIRECT -> ERROR).
        'x-correlation-id': correlationId
      };
    if(req.url.includes(environment.innovate.researchDefender.activityURL)){
      headerObject = {
        'Content-Type': 'application/json'
      }
    }
    const clonedRequest = req.clone({
      setHeaders: headerObject
    });
    return next.handle(clonedRequest);
  }
}